/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PuzzlePieceRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABq0lEQVR4nO1Vu0oDURBdEW0EQVQE9SssxB+ILmbnscXNTIxpU2kjgoiFoE2CqH9iYSUoCko+xQf4SCEoWqjcdVdj3NUsbjoHBvbCuefM3Hms4/xbWjPG9CJLDUgukPU1cNJLx3G6YrDdyHIV4YDlHFmrliNRwAI+iLnJUUdbsfm8GYvFslYTBcIovl0CkpXvwchaLJbl/KcM4iJ6BdInK2Iz8f3SuCUHkuckfGoBTOmx5Pn83EBHBIwxvUC6DSyNjgggy25WxJggcJ2xwEtGAnIFJJueX5hgLg/mcvN94BemPJbp1t7fSUsOLHueVxxy2rFKpdKDrFvIctcm+b5dE0FwvrrAcmDvAuk9sh4RFWaAtY4kZ6nbFEhuXLfUH87MRup5aCODdYsjKs6Ggs/IsmSfy+4mYF1tnvDUAszFyfe66WFY6KXPWmr91wySlh2GbjslwJHe2nNzoe2bf62Vnra/rjnKoDwYtvZd8znlD0ercZkA6UNECKwnrU+UqSEqRkX2SJYBdMQ1Zjj4ZmkAy8LfRVhqye2si5lkAiwErMdBa5I82u6ywxcB3gCOOWG0phi88gAAAABJRU5ErkJggg==)
 */
export const PuzzlePieceRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 7a3 3 0 0 0 2.98-3.31c-.03-.35.21-.69.56-.69H19a3 3 0 0 1 3 3v5.82c0 .2-.14.4-.33.49h-.02a.58.58 0 0 1-.44.05 7 7 0 0 0-9.08 7.99c.06.33-.18.65-.51.65H7a3 3 0 0 1-3-3v-2.5c0-.28-.23-.5-.5-.54a3 3 0 0 1 0-5.92c.27-.04.5-.26.5-.54V6a3 3 0 0 1 3-3h2.46c.35 0 .6.34.56.69L10 4a3 3 0 0 0 3 3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        className={colorClass}
      />
    </svg>
  );
};
